import officeImage from "../../assets/images/press/office.jpg";
import murckowskaImage from "../../assets/images/press/murckowska.jpg";
import office2Image from "../../assets/images/press/office2.jpg";

export const pressData = {
 
  oGrupieVehis: {
    title: 'O grupie VEHIS',
    description: 'VEHIS to platforma leasingowo-samochodowa, oferująca samochody wszystkich marek wraz z finansowaniem, ubezpieczeniem oraz wsparciem serwisowym. Finansowanie VEHIS to wyjątkowe połączenie korzyści leasingu i elastyczności najmu długoterminowego. Swoją ofertę kierujemy zarówno do przedsiębiorców, jak i konsumentów. Jesteśmy członkiem ZPL, największej organizacji reprezentującej branżę leasingową w Polsce.',
    items: [
      {
        id: 1,
        main_photo: officeImage,
        alt: 'Office'
      },
      {
        id: 2,
        main_photo: murckowskaImage,
        alt: 'Murckowska'
      },
      {
        id: 3,
        main_photo: office2Image,
        alt: 'Office 2'
      },
    ]
  },
};